import { render, staticRenderFns } from "./NavigationSupportBtn.vue?vue&type=template&id=3f6400e1&scoped=true"
import script from "./NavigationSupportBtn.vue?vue&type=script&lang=js"
export * from "./NavigationSupportBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6400e1",
  null
  
)

export default component.exports